// extracted by mini-css-extract-plugin
export default {"root":"WiseProductTabs_root__Fgh1d","tabsRoot":"WiseProductTabs_tabsRoot__SKxNy","indicator":"WiseProductTabs_indicator__m8QM5","tabRoot":"WiseProductTabs_tabRoot__AUC4K"};